@if(showSplash){
    <div class="splash-screen">
        @if(websiteJSONData){
            <img [src]="websiteJSONData['header']['favicon']" />
        }
    </div>
}

<router-outlet></router-outlet>